import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { AiPerformancePage } from '@/components/ai-performance/ai-performance-page';
import { DATE_RANGE_VALUES } from '@/lib/date-range';

const searchSchema = z.object({
  date_range: z.enum(DATE_RANGE_VALUES).default('LAST_30D'),
  start_date: z.string().optional(),
  end_date: z.string().optional(),
});

export const Route = createFileRoute('/_authenticated/ai-performance/')({
  validateSearch: searchSchema,
  staticData: {
    title: 'route.ai_performance.title',
    messageContext: { context_type: 'workspace' },
  },
  component: AiPerformancePage,
});
